import emrService from '@/apis/emr/service';
import EmrTag from '@/screens/CreateEmr/EmrInput/EmrTag';
import { IQuickModalResult, useQuickModalContext } from '@/utils/quickModal';
import { Button, Form } from 'antd';
import * as React from 'react';
import { useParams } from 'react-router-dom';

export interface IFormEditTagsEmrProps {
  emr: IEMRData;
  onCancel?: (modal: IQuickModalResult) => void;
  onOK?: (modal: IQuickModalResult, data?: any) => void;
}

const FormEditTagsEmr: React.FC<IFormEditTagsEmrProps> = ({ emr, onOK, onCancel, ...props }) => {
  const [form] = Form.useForm();
  const tags = emr?.data?.tags;
  const params = useParams();
  const uid = params.uid as string;
  const { mutate } = emrService.useUpsert();
  const { modal } = useQuickModalContext();
  return (
    <Form
      form={form}
      className="p-4"
      layout="vertical"
      onFinish={(value) => {
        emr.data.tags = value?.tags;
        mutate(
          { data: emr.data, tags: value?.tags, type: emr.type.code, uid: uid, _id: emr._id },
          {
            onSuccess(data) {
              {
                onOK ? onOK(modal, data) : modal.close();
              }
            },
          },
        );
      }}
    >
      <EmrTag labelProps={{ label: 'Gắn thẻ', initialValue: tags, name: 'tags' }} />
      <div className="flex mt-8 px-2 sticky bottom-0 left-0 w-full bg-quick-modal p-4 rounded-lg">
        <Form.Item className="w-1/2 pr-2 mb-0">
          <Button
            className="w-full"
            htmlType="button"
            onClick={async () => {
              onCancel ? onCancel(modal) : modal.close();
            }}
          >
            Đóng
          </Button>
        </Form.Item>

        <Form.Item className="w-1/2 mb-0">
          <Button type="primary" className="w-full  text-white" onClick={form.submit}>
            Lưu
          </Button>
        </Form.Item>
      </div>
    </Form>
  );
};
export default FormEditTagsEmr;
